import React from 'react';
import Profile from '../../../modules/Profile/components/Profile';

const ProfilePage = () => {
  return (
    <Profile />
  );
};

export default ProfilePage;